import {Currency, PriceObject} from 'types';

/**
 * Get currency char
 * @param {Currency} currency
 * @return {string}
 */
export function getCurrencyChar(currency: Currency): string {
  switch (currency) {
    case Currency.RUB: return '₽';
    case Currency.USD: return '$';
  }
}

/**
 * Get price label
 * @param {PriceObject} price
 * @return {string}
 */
export default function getPriceLabel(price: PriceObject): string {
  return `${price.amount} ${getCurrencyChar(price.currency)}`;
}
